import { RegistrationSuccessScreen } from '@/modules/onboarding/registration';
export default RegistrationSuccessScreen;
